import { getFromStorage } from "utils/storage";
import { create } from "zustand";

export const getUserType = create((set, get) => ({
  isUserType:getFromStorage("user_data")?.user_role ||   null,
  userData: getFromStorage("user_data") || null,

  // isUserType: "admin",
  // isUserType: "customer",
  // isUserType: "greUser",
  // isUserType: "globalUser",
  // isUserType: "salesPerson",
  // isUserType: "superAdmin",
  setUserType: (payload) => {
    set((state) => ({
      isUserType: payload,
    }));
  },
  setUserData: (payload) => {
    set((state) => ({
      userData: payload,
    }));
  },
}));
